import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { approvedGuard } from './guards/approved.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.page').then(m => m.LandingPage),
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./pages/auth-callback/auth-callback.page').then(m => m.AuthCallbackPage),
  },
  {
    path: 'apply',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/apply/apply.page').then(m => m.ApplyPage),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.page').then(m => m.DashboardPage),
  },
  {
    path: 'dashboard/keslr-network',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/keslr-network-list/keslr-network-list.page').then(m => m.KeslrNetworkListPage),
  },
  {
    path: 'dashboard/keslr-network/new',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/keslr-network-new/keslr-network-new.page').then(m => m.KeslrNetworkNewPage),
  },
  {
    path: 'dashboard/keslr-network/:id',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/keslr-network-detail/keslr-network-detail.page').then(m => m.KeslrNetworkDetailPage),
  },
  {
    path: 'dashboard/oidc',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/oidc-list/oidc-list.page').then(m => m.OIDCListPage),
  },
  {
    path: 'dashboard/oidc/new',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/oidc-new/oidc-new.page').then(m => m.OIDCNewPage),
  },
  {
    path: 'dashboard/oidc/:id',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/oidc-detail/oidc-detail.page').then(m => m.OIDCDetailPage),
  },
  {
    path: 'dashboard/support',
    canActivate: [authGuard, approvedGuard],
    loadComponent: () => import('./pages/support/support.page').then(m => m.SupportPage),
  },
  {
    path: 'docs',
    // canActivate: [authGuard],
    loadComponent: () => import('./pages/docs-hub/docs-hub.page').then(m => m.DocsHubPage),
  },
  {
    path: 'docs/keslr-network',
    // canActivate: [authGuard],
    loadComponent: () => import('./pages/docs-keslr-network/docs-keslr-network.page').then(m => m.DocsKeslrNetworkPage),
  },
  {
    path: 'docs/keslr-id',
    // canActivate: [authGuard],
    loadComponent: () => import('./pages/docs-keslr-id/docs-keslr-id.page').then(m => m.DocsKeslrIdPage),
  },
  {
    path: 'docs/api-reference',
    // canActivate: [authGuard],
    loadComponent: () => import('./pages/docs-api-reference/docs-api-reference.page').then(m => m.DocsApiReferencePage),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
